import React from 'react';
import {connect} from 'react-redux';
import {Trans, withTranslation} from 'react-i18next';
import AutoCompletion from './components/auto-completion/index';
import {
    getAddedCollaborators,
    autoCompleteEnteredValue,
    share,
    findCollaborators, getSharingDetailsPopup,
    resetCollaborators
} from '../../../../../../../actions/sharingDetailsActions';
import AddToContact from './components/add-to-contact/index';
import AddCollaboratorsField from './components/add-collaborators-field/index';
import UpdateDirectory from './components/update-directory/index';
import {hasDuplicatedEmail, isEmailValid, isEmpty} from '../../../../../../../actions/addCollaboratorActions';
import RightSelection from "./components/right-selection";
import SharingButton from './components/sharing-button';
import ListOfCollaborators from './components/list-of-collaborators';
import {labelStateUpdating, postCreateLabel} from "../../../../../../../actions/contactsGroupItemActions";
import Notify from "./components/notify";
import Loader from "../../../../../../components/sprite/components/loader";
import MsgSharingDetailsBar from './components/msg-sharing-details-bar';
import './index.css';
import SwitchButton from '../../../../../../components/switch-button';
import {toggleOrgUnit} from '../../../../../../../actions/directoryGroupActions';
import {sharedWordRemove} from '../../../../../../utils';

class AddCollaboratorsPopup extends React.Component {

	constructor(props){
		super(props);

		this.state = {
			selectedActive: false,
			selectedIndex: -1,
		};

		this.remainingCollaboratorsCall = null;
		this.addCollaborator = this.addCollaborator.bind(this);
		this.handleToggleOrgUnit = this.handleToggleOrgUnit.bind(this);
        this.share = this.share.bind(this);
		this.getTargetGroup = this.getTargetGroup.bind(this);
	}

	fetchCollaboratorsData = () => {
		if (this.props.resetCollaborators) {
			this.props.resetCollaborators();
		}
		if (this.props.sharingDetailsPopup && this.props.sharingDetailsPopup[2]) {
			let cleanLabelId = this.props.sharingDetailsPopup[2];
			let targetOwnerId = this.props.sharingDetailsPopup[4];
			if (typeof cleanLabelId === 'string' && cleanLabelId.includes('-') && /^\d+-/.test(cleanLabelId)) {
				const parts = cleanLabelId.split('-');
				cleanLabelId = parts[0];
				if (!targetOwnerId) targetOwnerId = parts[1];
			}
			this.props.setFindCollaborators(cleanLabelId, this.props.collaboratorsPageSize, targetOwnerId);
		} else if (this.props.selectedContactsGroup) {
			if (this.props.selectedContactsGroup.type === "system") {
				this.props.setFindCollaborators(6, this.props.collaboratorsPageSize, this.props.profile && this.props.profile.id);
			} else {
				this.props.setFindCollaborators(this.props.selectedContactsGroup.id, this.props.collaboratorsPageSize, this.props.selectedContactsGroup.ownerId);
			}
		}
	};

	componentDidMount() {
		this.fetchCollaboratorsData();
	}

	componentDidUpdate(prevProps) {
		const normalizeId = (id) => {
			if (typeof id === 'string' && id.includes('-') && /^\d+-/.test(id)) {
				return id.split('-')[0];
			}
			return id != null ? String(id) : null;
		};
		const prevLabelId = normalizeId(prevProps.sharingDetailsPopup ? prevProps.sharingDetailsPopup[2] : null);
		const currentLabelId = normalizeId(this.props.sharingDetailsPopup ? this.props.sharingDetailsPopup[2] : null);
		const prevOwnerId = prevProps.sharingDetailsPopup ? prevProps.sharingDetailsPopup[4] : null;
		const currentOwnerId = this.props.sharingDetailsPopup ? this.props.sharingDetailsPopup[4] : null;

		if (prevLabelId !== currentLabelId || prevOwnerId !== currentOwnerId) {
			this.fetchCollaboratorsData();
		}
	}

    componentWillUnmount(){
		if (this.props.resetCollaborators) {
			this.props.resetCollaborators();
		}
	}

	addCollaborator(e){

        document.getElementById('addCollaboratorsField').focus();

		this.props.setAutoCompleteEnteredValue("");

		if(this.props.isEmpty){
			this.props.setIsEmpty(false);
		}

		if(this.props.isEmailValid === false){
			this.props.setIsEmailValid(true);
		}

		if(this.props.hasDuplicatedEmail){
			this.props.setHasDuplicatedEmail(false);
		}

		/*
		* If a click event is triggered
		* */

		let collaboratorsArray = [];
		const clickedId = e.currentTarget.id;

		this.props.autoComplete.forEach(item => {
			if(String(item.id || item.email) === String(clickedId) || String(item.email) === String(clickedId)){
				const effectivePermission = (item.userRole === 'RESTRICTED_USER' && (this.props.rightToAdd === 'CAN_SHARE' || this.props.rightToAdd === 'OWNER'))
					? 'READ_ONLY'
					: this.props.rightToAdd;
				collaboratorsArray = collaboratorsArray.concat({
					"groupId": (this.props.sharingDetailsPopup && this.props.sharingDetailsPopup[2]) || (this.props.selectOneLabelFromPopup && this.props.selectOneLabelFromPopup.id) || (this.props.selectedContactsGroup && (this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id)),
					"id": item.id ? item.id : item.email,
					"name": item.name,
					"email": item.email,
					"permission": effectivePermission,
					"type": item.type,
					"userRole": item.userRole,
					"addToContact": false,
					"toRemove": false
				});
			}

			return collaboratorsArray;
		});

		if (collaboratorsArray.length > 0) {
			this.props.getAddedCollaborators(...collaboratorsArray);
		}
		document.getElementById("addCollaboratorsField").value = "";
	}

    share(){

		if(this.props.sharingDetailsPopup[2]){
			this.props.labelStateUpdating(this.props.sharingDetailsPopup[2]);
		} else {
			this.props.labelStateUpdating(this.props.selectedContactsGroup.id);
		}


	    if(document.getElementById("addCollaboratorsField").value.trim() === "" && this.props.addedCollaborators.length === 0){
		    this.props.setIsEmpty(true);
	    } else if (this.props.targetedContact && this.props.findLabels.contactsGroups.length === 0) {

		    /*
			* TargetedContact with no label
			* */

		    this.props.postCreateLabel('🥳 My First Shared Group', true);

	    } else {
		    this.props.share();
	    }

    }

	displayPopupSharingInfoTitle () {
		const currentLabelName = (this.props.sharingDetailsPopup && this.props.sharingDetailsPopup[3]) || (this.props.selectedContactsGroup && this.props.selectedContactsGroup.name);

		if(this.props.selectSeveralContactsGroups.length > 0 && !this.props.sharingDetailsPopup[3]){

			let activeLabelInsideSeveralSelectedLabels = false;

			this.props.selectSeveralContactsGroups.forEach( item => {
				if(item.name === this.props.selectedContactsGroup.name) {
					activeLabelInsideSeveralSelectedLabels = true;
				}
			});

			if(this.props.selectSeveralContactsGroups.length > 2){

				/*
				* Three or more selected
				* */

				if(activeLabelInsideSeveralSelectedLabels){
					return <Trans i18nKey="popupSharingInfoAndMoreLabels" values={
						{
							labelName: currentLabelName,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				} else {
					return <Trans i18nKey="popupSharingInfoAndMoreLabels" values={
						{
							labelName: this.props.selectSeveralContactsGroups[0].name,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				}
			} else if (this.props.selectSeveralContactsGroups.length > 1) {

				/*
				* Two or more selected
				* */

				if(activeLabelInsideSeveralSelectedLabels){
					return <Trans i18nKey="popupSharingInfoAndOneLabel" values={
						{
							labelName: currentLabelName,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				} else {
					return <Trans i18nKey="popupSharingInfoAndOneLabel" values={
						{
							labelName: this.props.selectSeveralContactsGroups[0].name,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				}
			} else {

				/*
				* Only One selected
				* */

				if(activeLabelInsideSeveralSelectedLabels){
					return <Trans i18nKey="popupSharingInfo" values={
						{
							labelName: currentLabelName
						}
					}/>
				} else {
					return <Trans i18nKey="popupSharingInfo" values={
						{
							labelName: this.props.selectSeveralContactsGroups[0].name
						}
					}/>
				}

			}

		} else {
			return <Trans i18nKey="popupSharingInfo" values={
				{
					labelName: currentLabelName
				}
			}/>
		}
	}

	getTargetGroup() {
		let targetLabelId = this.props.sharingDetailsPopup && this.props.sharingDetailsPopup[2];
		if (!targetLabelId) {
			return this.props.selectedContactsGroup || {};
		}
		if (typeof targetLabelId === 'string' && targetLabelId.includes('-') && /^\d+-/.test(targetLabelId)) {
			targetLabelId = targetLabelId.split('-')[0];
		}
		// 1. Search in directoryContactGroupsV4 (rootOu, childOu, childOuLv2)
		if (this.props.findDirectoryGroups && this.props.findDirectoryGroups.directoryContactGroupsV4) {
			for (const dirGroup of this.props.findDirectoryGroups.directoryContactGroupsV4) {
				if (dirGroup.rootOu && String(dirGroup.rootOu.id) === String(targetLabelId)) {
					return {
						...dirGroup.rootOu,
						type: "directory"
					};
				}
				if (dirGroup.rootOu && dirGroup.rootOu.childOu) {
					for (const child1 of dirGroup.rootOu.childOu) {
						if (String(child1.id) === String(targetLabelId)) {
							return {
								...child1,
								type: "childDirectory",
								parentName: child1.parentName || dirGroup.rootOu.name,
								ouSharingPermission: child1.ouSharingPermission || 'INHERIT_FROM_PARENT'
							};
						}
						if (child1.childOu) {
							for (const child2 of child1.childOu) {
								if (String(child2.id) === String(targetLabelId)) {
									return {
										...child2,
										type: "childDirectoryLv2",
										parentName: child2.parentName || child1.name,
										ouSharingPermission: child2.ouSharingPermission || 'INHERIT_FROM_PARENT'
									};
								}
							}
						}
					}
				}
			}
		}
		// 2. Search in findLabels
		if (this.props.findLabels) {
			const groups = Array.isArray(this.props.findLabels)
				? this.props.findLabels
				: (this.props.findLabels.contactsGroups || []);
			const found = groups.find(l => String(l.id) === String(targetLabelId));
			if (found) return found;
		}
		// 3. Fallback to selectedContactsGroup if id matches
		if (this.props.selectedContactsGroup && String(this.props.selectedContactsGroup.id) === String(targetLabelId)) {
			return this.props.selectedContactsGroup;
		}
		return {};
	}

	handleToggleOrgUnit () {
		const targetGroup = this.getTargetGroup();
		const groupId = targetGroup.id || (this.props.selectedContactsGroup && this.props.selectedContactsGroup.id);
		const ownerId = targetGroup.ownerId || (this.props.selectedContactsGroup && this.props.selectedContactsGroup.ownerId);
		const isChildOu = targetGroup.type === "childDirectory" 
			|| targetGroup.type === "childDirectoryLv2"
			|| (Boolean(targetGroup.ouSharingPermission) && Boolean(targetGroup.parentName));
		const ouSharingPermission = targetGroup.ouSharingPermission || (isChildOu ? 'INHERIT_FROM_PARENT' : undefined);

		if (ouSharingPermission === 'INHERIT_FROM_PARENT') {
			this.props.toggleOrgUnit(groupId, 'SPECIFIC_PERMISSIONS', ownerId);
		} else {
			this.props.toggleOrgUnit(groupId, 'INHERIT_FROM_PARENT', ownerId);
		}
	}

	render(){
		if(this.props.findLabels && this.props.findCollaborators){
			const targetGroup = this.getTargetGroup();
			const isChildOu = targetGroup.type === "childDirectory" 
				|| targetGroup.type === "childDirectoryLv2"
				|| (Boolean(targetGroup.ouSharingPermission) && Boolean(targetGroup.parentName));
			const ouSharingPermission = targetGroup.ouSharingPermission || (isChildOu ? 'INHERIT_FROM_PARENT' : undefined);
			const parentName = targetGroup.parentName || '';
			const targetPermission = targetGroup.permission || 'CAN_EDIT';

			if(targetPermission === 'READ_ONLY'){
				return (
					<div className="add-collaborators position-relative">
						{this.props.t("textNoAccessSharingSetting")}
					</div>
				)
			} else {
				return (
					<div className="add-collaborators position-relative">
						{
							(this.props.selectedCollaborator === null) && <div>
								<div className="d-flex align-items-center mb-3">
									<div
										className="pic bg-primary rounded-circle d-flex align-items-center justify-content-center mr-2 text-center">
										<svg width="1em" height="1em" viewBox="0 0 16 16">
											<line fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      x1="5.425" y1="9.046" x2="10.575" y2="11.62"/>
											<line fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      x1="5.425" y1="6.954" x2="10.575" y2="4.379"/>
											<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      d="M15,3.334c0,1.287-1.046,2.332-2.333,2.332 s-2.334-1.045-2.334-2.332C10.333,2.046,11.38,1,12.667,1S15,2.046,15,3.334"/>
											<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      d="M15,12.667C15,13.954,13.954,15,12.667,15 s-2.334-1.046-2.334-2.333s1.047-2.334,2.334-2.334S15,11.38,15,12.667"/>
											<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      d="M5.666,8c0,1.287-1.045,2.333-2.332,2.333 C2.046,10.333,1,9.287,1,8s1.046-2.334,2.334-2.334C4.62,5.666,5.666,6.713,5.666,8"/>
										</svg>
									</div>
									<h2>
										{this.displayPopupSharingInfoTitle()}
									</h2>
								</div>
								{
									isChildOu && <div className="d-flex my-4 justify-content-around">
										<div>
											Inherited from {sharedWordRemove(parentName)}
										</div>
										<div>
											<SwitchButton
												active={ouSharingPermission === 'SPECIFIC_PERMISSIONS'}
												onClick={ this.handleToggleOrgUnit }
											/>
											Specific permission
										</div>
									</div>
								}
								<div className={`add-collaborators_area${isChildOu && ouSharingPermission === "INHERIT_FROM_PARENT" ? ' disabled': ''}`}>
									<div className="d-flex align-items-stretch mb-2">
										<div className={`input-group collaborators-field-wrapper${this.props.isSharing || (this.props.isUserListAddCollaboratorsPopupShown && !this.props.selectOneLabelFromPopup) ? ' collaborators-field-wrapper__disabled' : ''}`}>
											<div className="input-wrapper d-flex p-1">
												<AddCollaboratorsField launchShare={this.share}/>
											</div>
											<div className="input-group-append">
												<UpdateDirectory/>
											</div>
										</div>
										{
											this.props.addedCollaborators.length
												?
												<RightSelection/>
												:
												null
										}
									</div>
									{
										this.props.isEmpty
										?
											<div className="alert alert-danger mt-3">{this.props.t("fieldEmpty")}.</div>
										:
											this.props.isEmailValid === false
											?
												<div className="alert alert-danger mt-3">{this.props.t("popupSharingInvalidEmailError")}.</div>
											:
												this.props.hasDuplicatedEmail
												?
													<div className="alert alert-danger mt-3">{this.props.t("emailExistAlreadyText")}
														</div>
												:
													null
									}
									{
										this.props.autoCompleteEnteredValue.length > 1
										?
											<AutoCompletion
												selectedIndex={this.state.selectedIndex}
												selectedActive={this.state.selectedActive}
												addCollaboratorClickHandler={this.addCollaborator}
											/>
										:
											null
									}
									<AddToContact/>
									<Notify/>
									<SharingButton from={this.props.sharingDetailsPopup[2]}/>
								</div>
							</div>
						}
						{
							this.props.findCollaborators.collaborators?.length > 1 && this.props.sharingDetailsPopup[2] !== "severalLabels" && <ListOfCollaborators disabled={
								isChildOu && ouSharingPermission === "INHERIT_FROM_PARENT" ? ' disabled': ''
							}/>
						}
						{
							this.props.msgSharingDetailsBar.length > 0
							&& <MsgSharingDetailsBar/>
						}
					</div>
				)
			}

		} else {
			return <Loader/>
		}

	}
}

const mapStateToProps = (state) => {
	return {
		findLabels: state.contactsGroupItemReducer.findLabels,
		findDirectoryGroups: state.directoryGroupReducer.findDirectoryGroups,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		autoCompleteEnteredValue : state.sharingDetailsReducer.autoCompleteEnteredValue,
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        selectSeveralContactsGroups: state.contactsGroupItemReducer.selectSeveralContactsGroups,
        collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
        addedCollaborators: state.sharingDetailsReducer.getAddedCollaborators,
        autoComplete: state.sharingDetailsReducer.getAutoComplete,
		profile: state.profileReducer.getProfile,
		isEmpty: state.addCollaboratorDetailsReducer.isEmpty,
		isEmailValid: state.addCollaboratorDetailsReducer.isEmailValid,
		hasDuplicatedEmail: state.addCollaboratorDetailsReducer.hasDuplicatedEmail,
		rightToAdd: state.sharingDetailsReducer.rightToAdd,
		selectedContacts: state.contactReducer.selectedContacts,
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		setGmailAddOnData: state.profileReducer.setGmailAddOnData,
		targetedContact: state.contactReducer.targetedContact,
		selectedCollaborator: state.sharingDetailsReducer.selectedCollaborator,
		msgSharingDetailsBar: state.msgBarReducer.msgSharingDetailsBar,
		isUserListAddCollaboratorsPopupShown: state.popupReducer.isUserListAddCollaboratorsPopupShown,
		selectOneLabelFromPopup: state.contactsGroupItemReducer.selectOneLabelFromPopup,
		isSharing : state.sharingDetailsReducer.isSharing
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        setFindCollaborators : (selectedLabelId, pageSize, ownerId) => {
            dispatch(findCollaborators(selectedLabelId, pageSize, ownerId))
        },
		setAutoCompleteEnteredValue : (string) => {
			dispatch(autoCompleteEnteredValue(string))
		},
		getAddedCollaborators : (array) => {
			dispatch(getAddedCollaborators(array))
		},
        share : (object) => {
            dispatch(share(object))
        },
		setIsEmpty : (boolean) => {
			dispatch(isEmpty(boolean))
		},
		setIsEmailValid : (boolean) => {
			dispatch(isEmailValid(boolean))
		},
		setHasDuplicatedEmail : (boolean) => {
			dispatch(hasDuplicatedEmail(boolean))
		},
        postCreateLabel: (string, boolean, contact) => {
            dispatch(postCreateLabel(string, boolean, contact))
        },
        labelStateUpdating: (labelId) => {
            dispatch(labelStateUpdating(labelId))
        },
		toggleOrgUnit: (groupId, ouSharingPermission, ownerId) => {
			dispatch(toggleOrgUnit(groupId, ouSharingPermission, ownerId))
		},
		resetCollaborators: () => {
			dispatch(resetCollaborators())
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddCollaboratorsPopup));
